import { fg } from '@atlassian/jira-feature-gating';

import type {
	AssetsPermissionResponse,
	AssetsPermissionsApiResponse,
} from './AssetsPermissionResponse.types.tsx';

const HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
const HEADER_X_SSR_ASAP_AUDIENCE = 'x-ssr-asap-audience';
const HEADER_ATL_CLOUDID = 'atl-cloudid';

export const transformAssetsPermissionResponse = (
	response: AssetsPermissionsApiResponse,
	apiCallSuccess: boolean,
): AssetsPermissionResponse => {
	return {
		isAssetsAdmin: response.isAdmin,
		isLicensedAssetsUser: apiCallSuccess && response.hasAssetsAccess,
	};
};

export const getAssetsPermissionUrl = (workspaceId: string): string => {
	// When on client, always use gateway URL
	if (!__SERVER__) {
		return `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/permissions/permitted`;
	}

	// When on server, use hostname routing when new FG is enabled
	if (fg('assets_permission_hostname_routing')) {
		return '/assets/api/v1/permissions/permitted';
	}

	// Default SSR fallback: use gateway internal route
	return '/internal/permissions/permitted';
};

export const getAssetsPermissionHeaders = (
	workspaceId: string,
	cloudId: string,
): Record<string, string> => {
	// When on client, always use gateway headers
	if (!__SERVER__) {
		return {
			[HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
			[HEADER_ATL_WORKSPACEID]: workspaceId,
		};
	}

	// When on server, use hostname routing headers when new FG is enabled
	if (fg('assets_permission_hostname_routing')) {
		return {
			[HEADER_X_SSR_ASAP_AUDIENCE]: 'assets-tempeh-archetype',
		};
	}

	// Default SSR fallback: use gateway headers
	return {
		[HEADER_ATL_CLOUDID]: cloudId,
		[HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
		[HEADER_ATL_WORKSPACEID]: workspaceId,
	};
};
